import React, { useEffect, useMemo, useState } from 'react';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import BaseModal from './BaseModal';
import { WorksForm, TrainingsForm, SkillsForm, IndustriesForm, FunctionsForm, EducationsForm } from './components';
import { getBlocksSettings, getInitialValues, getValidationSchema } from './helpers/addEditForm';
import { useWindowSize } from '../../../utils/hooks';
import { maxMobileSize, maxSymbolQTY, validationMessages } from '../../../utils/constants';

function AddEditFormModal(props) {
  const {
    open,
    closeHandler,
    confirmHandler,
    pending = false,
    error = false,
    editeMode,
    initData,
    block,
    extra,
    withCurrentlyCheckBox
  } = props;

  const size = useWindowSize();

  const [isConfirmUnAllowed, setIsConfirmUnAllowed] = useState(false);
  const { t } = useTranslation();

  let resultInitData = ['functions', 'industries', 'skills'].includes(block) ? initData : { ...initData };

  if (withCurrentlyCheckBox) {
    resultInitData = {
      ...resultInitData,
      withCurrentlyCheckBox,
      ...extra,
      originalValue: block === 'works' ? initData?.CurrentlyWorkThere : initData?.CurrentlyStudyHere
    };
  }

  const addEditForm = useFormik({
    initialValues: getInitialValues(editeMode, resultInitData, block, t),
    validationSchema: getValidationSchema(block, resultInitData, t),
    initialTouched:
      editeMode &&
      Object.keys(getInitialValues(editeMode, resultInitData, block, t)).reduce((acc, key) => {
        acc[key] = true;
        return acc;
      }, {}),
    onSubmit: (values) => confirmHandler(values)
  });

  const componentsForBlocks = {
    works: <WorksForm withCurrentlyCheckBox={withCurrentlyCheckBox} addEditForm={addEditForm} />,
    educations: <EducationsForm withCurrentlyCheckBox={withCurrentlyCheckBox} addEditForm={addEditForm} />,
    trainings: <TrainingsForm addEditForm={addEditForm} />,
    skills: <SkillsForm addEditForm={addEditForm} extra={extra} />,
    industries: <IndustriesForm addEditForm={addEditForm} />,
    functions: <FunctionsForm addEditForm={addEditForm} />
  };

  const changeDisableConfirmState = () => {
    if (
      (block === 'educations' &&
        (addEditForm.values.school?.length > maxSymbolQTY.SCHOOL ||
          addEditForm.values.degree?.length > maxSymbolQTY.DEGREE ||
          addEditForm.values.fieldofstudy?.length > maxSymbolQTY.FIELD_OF_STUDY)) ||
      (block === 'trainings' &&
        (addEditForm.values.type?.length > maxSymbolQTY.TYPE ||
          addEditForm.values.certId?.length > maxSymbolQTY.CERTIFICATE_ID))
    ) {
      setIsConfirmUnAllowed(true);
    } else {
      setIsConfirmUnAllowed(false);
    }
  };

  useEffect(() => {
    addEditForm.validateForm();
  }, []);

  useEffect(() => {
    changeDisableConfirmState();
  }, [
    addEditForm.values.school,
    addEditForm.values.degree,
    addEditForm.values.fieldofstudy,
    addEditForm.values.type,
    addEditForm.values.certId
  ]);

  return (
    <BaseModal
      open={open}
      fullscreen={size.width < maxMobileSize}
      closeHandler={closeHandler}
      confirmHandler={addEditForm.handleSubmit}
      pending={pending}
      disableConfirmBtn={isConfirmUnAllowed}
      error={error}
      title={`${editeMode ? t('common.general.edit') : t('common.general.add')} ${
        getBlocksSettings(block, resultInitData, t).windowTitle
      }`}
    >
      {componentsForBlocks[block]}
    </BaseModal>
  );
}

export default AddEditFormModal;
